// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.view-img[data-v-26a5d464] {\r\n  border: 1px solid black;\r\n  width: 200px;\n}\n.view-vid[data-v-26a5d464] {\r\n  width: 200px !important;\r\n  height: 200px !important;\n}\n.view-vid-wrapper[data-v-26a5d464] {\r\n  height: 200px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
